// This file was auto-generated by Fern from our API Definition.
export var ChannelDestination;
(function (ChannelDestination) {
    ChannelDestination.Type = {
        Channel: "channel",
    };
})(ChannelDestination || (ChannelDestination = {}));
